import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertConfig } from '../contacts/user.service';
import { environment } from 'src/environments/environment';

export interface OrganizationConfiguration {
  alertConfig: AlertConfig | null;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  #http = inject(HttpClient);

  private get baseUrl(): string {
    return `${environment.urls.standaloneApi}/v1/organization/configuration`;
  }

  getConfiguration(): Observable<OrganizationConfiguration> {
    return this.#http.get<OrganizationConfiguration>(this.baseUrl);
  }

  saveConfiguration(alertConfig: AlertConfig): Observable<OrganizationConfiguration> {
    return this.#http.put<OrganizationConfiguration>(this.baseUrl, alertConfig);
  }
}
